/**
 * EN-1510: display order for the "Select Waveform to Verify" dialog.
 */

/** Display order for waveform types: ELF, MAG, GEO, INGEO, TMR, Manual. */
const WAVEFORM_TYPE_ORDER = ['E', 'M', 'G', 'A', 'T', 'H'];

function typeRank(type: string | null | undefined): number {
  const i = WAVEFORM_TYPE_ORDER.indexOf(type ?? '');
  return i === -1 ? WAVEFORM_TYPE_ORDER.length : i;
}

/**
 * Deterministic order for the waveform verify previews. The API returns
 * a passage's waveforms in no fixed order, so the options moved around
 * between opens. Sort by type (ELF, MAG, GEO, ...), unknown types last by
 * type code, then by passageWaveformId. Returns a new array.
 */
export function sortWaveformsForVerify<
  T extends { passageWaveformType: string; passageWaveformId: number }
>(waveforms: readonly T[] | null | undefined): T[] {
  return [...(waveforms ?? [])].sort((a, b) => {
    const rank =
      typeRank(a.passageWaveformType) - typeRank(b.passageWaveformType);
    if (rank !== 0) return rank;
    const type = (a.passageWaveformType ?? '').localeCompare(
      b.passageWaveformType ?? ''
    );
    if (type !== 0) return type;
    return a.passageWaveformId - b.passageWaveformId;
  });
}
